export default {
  state: {
    small: '22px',
    medium: '24px',
    large: '26px'
  },
  mutations: {},
  actions: {}
};
